(function(){
'use strict';
var root = document.getElementById('icb'); if (!root) return;
var data = JSON.parse(document.getElementById('icb-data').textContent);
var byHandle = {}; data.products.forEach(function(pr){ byHandle[pr.handle] = pr; });
var cur = byHandle[data.current];
function single(pr){ return pr.variants.length === 1; }
var state = { qty: 2, slots: [] };
for (var i = 0; i < 2; i++) state.slots.push({ handle: i === 0 ? data.current : null, size: null });
if (single(cur)) state.slots[0].size = cur.variants[0].t;
var PO = root.dataset.preorder === '1' || /[?&]po_test=1/.test(location.search);
var SHIP = root.dataset.ship || 'Oct 27';
function isPO(h){ if (!h) return false; var pr = byHandle[h]; return (pr && pr.kind === 'boxing') || (PO && h === data.current); }
function poCount(){ var n = 0; for (var i = 0; i < state.qty; i++) if (isPO(state.slots[i].handle)) n++; return n; }
var atc = document.getElementById('icb-atc');
var atcLabel = atc.querySelector('.icb-atc-label');
var atcPrice = atc.querySelector('.icb-atc-price');
var note = document.getElementById('icb-atc-note');
var sticky = document.getElementById('icb-sticky');
var stickyPrice = document.getElementById('icb-sticky-price');
var stickyBtn = document.getElementById('icb-sticky-btn');
function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function money(cents){
var fmt = data.money || '${{amount}}', n = Math.round(cents);
var whole = Math.floor(n / 100), dec = ('0' + (n % 100)).slice(-2);
var withC = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
if (k === 'amount_no_decimals') return withC;
if (k === 'amount_with_comma_separator') return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
return withC + '.' + dec;
});
}
function shortTitle(t){ return String(t).replace(/^Z-GUARD BOXING GLOVE\s*/i, 'Z-GUARD ').replace(/^LACE-UP MMA GLOVE\s*/i, 'MMA '); }
function slotCents(s){
if (!s.handle) return null;
var pr = byHandle[s.handle];
if (s.size){ for (var k = 0; k < pr.variants.length; k++) if (pr.variants[k].t === s.size) return pr.variants[k].c; }
return pr.cents;
}
function totals(){
var a = slotCents(state.slots[0]) || cur.cents;
if (state.qty === 1) return { full: a, total: a };
var b = slotCents(state.slots[1]); if (b === null) b = a;
return { full: a + b, total: a + b - Math.round(Math.min(a, b) * 0.3) };
}
function activeBody(){ return root.querySelector('.icb-tier-body[data-body="'+state.qty+'"]'); }
if (PO){
var left = /[?&]po_test=1/.test(location.search) ? 17 : Number(root.dataset.left || 0);
var shipLong = root.dataset.shipLong || SHIP;
var card = document.createElement('div'); card.className = 'icb-po';
card.innerHTML =
'<div class="icb-po-head"><svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M3.5 10h17M8 3v4M16 3v4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span><b>Pre-order</b> · Ships '+esc(shipLong)+'</span></div>' +
'<div class="icb-po-line"><span>Today<small>You order</small></span><span>'+esc(SHIP)+'<small>It ships</small></span><span>Then<small>Tracked to you</small></span></div>' +
(left > 0 ? '<div class="icb-po-left"><i></i>Only '+left+' pairs left in this color</div>' : '');
var top = root.querySelector('.icb-top'); if (top) top.appendChild(card);
var trust = root.querySelector('.icb-trust');
if (trust) trust.insertAdjacentHTML('afterbegin',
'<li class="icb-trust-po"><svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Cancel any time before it ships. Full refund.</li>' +
'<li class="icb-trust-po"><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M8.5 12l2.5 2.5 4.5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Price locked at '+esc(root.dataset.price || money(cur.cents))+'. You keep it after the price goes up.</li>');
}
function slotHtml(i){
var s = state.slots[i], label = 'Pair '+(i+1)+(state.qty === 2 && i === 1 ? ' · 30% off' : '');
if (!s.handle){
return '<div class="icb-slot is-empty" data-i="'+i+'">' +
'<div class="icb-slot-head">' +
'<span class="icb-slot-empty" aria-hidden="true">+</span>' +
'<div class="icb-slot-name"><span class="icb-slot-n">'+label+'</span>' +
'<span class="icb-slot-t">Pick any glove</span></div>' +
'<button type="button" class="icb-choose" data-pick="'+i+'">Choose</button>' +
'</div><div class="icb-size-hint">Pick a glove for pair '+(i+1)+'</div></div>';
}
var pr = byHandle[s.handle];
var html = '<div class="icb-slot" data-i="'+i+'">' +
'<div class="icb-slot-head">' +
'<img class="icb-slot-img" src="'+esc(pr.img)+'" alt="">' +
'<div class="icb-slot-name"><span class="icb-slot-n">'+label+'</span>' +
'<span class="icb-slot-t">'+esc(shortTitle(pr.title))+'</span>' +
(isPO(s.handle) ? '<span class="icb-slot-po">Pre-order · ships '+esc(SHIP)+'</span>' : '') + '</div>' +
'<button type="button" class="icb-change" data-pick="'+i+'">Change</button>' +
'</div>';
if (!single(pr)){
html += '<div class="icb-sizes">';
pr.variants.forEach(function(v){
html += '<button type="button" class="icb-size'+(s.size===v.t?' is-on':'')+'" data-i="'+i+'" data-size="'+esc(v.t)+'"'+(v.a?'':' disabled')+'>'+esc(v.t)+(v.a?'':' · sold out')+'</button>';
});
html += '</div><div class="icb-size-hint">Pick a size for pair '+(i+1)+'</div>';
}
return html + '</div>';
}
function renderSlots(){
root.querySelectorAll('.icb-tier-body').forEach(function(b){ b.innerHTML = ''; });
var body = activeBody(); if (!body) return;
var html = '';
for (var i = 0; i < state.qty; i++) html += slotHtml(i);
if (state.qty === 1){
html += '<button type="button" class="icb-nudge" data-nudge="2">' +
'<span class="icb-nudge-box" aria-hidden="true">+</span>' +
'<span class="icb-nudge-name"><span class="icb-nudge-t">Add a 2nd pair</span>' +
'<span class="icb-nudge-s">30% off the 2nd pair + free shipping · Boxing or MMA</span></span></button>';
}
body.innerHTML = html;
updateCta();
}
function updateCta(){
var q = state.qty, t = totals(), po = poCount();
if (po){
atcLabel.textContent = q === 1 ? 'Pre-order' : 'Pre-order 2';
stickyBtn.textContent = 'Pre-order';
} else {
atcLabel.textContent = q === 1 ? 'Add to cart' : 'Add 2 to cart';
stickyBtn.textContent = 'Add to cart';
}
atcPrice.textContent = money(t.total);
stickyPrice.textContent = money(t.total) + (q > 1 ? ' · 2 pairs' : '');
var t2 = root.querySelector('[data-total="2"]'), f2 = root.querySelector('[data-full="2"]');
if (q === 2 && t2){ t2.textContent = money(t.total); f2.textContent = money(t.full); }
if (po){
var when = po === q ? 'Ships '+SHIP+'.' : 'Z-GUARD ships '+SHIP+'.';
note.textContent = q === 1 ? when+' Cancel any time before it ships.'
: '30% off the 2nd pair + free shipping. '+when;
} else {
note.textContent = q === 1 ? 'Add a 2nd pair: 30% off it and free shipping.'
: '30% off the 2nd pair + free shipping, applied automatically at checkout.';
}
root.dataset.qty = q;
}
function setTier(q){
state.qty = q;
root.querySelectorAll('.icb-tier').forEach(function(t){
var on = Number(t.dataset.tier) === q;
t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on ? 'true' : 'false');
});
renderSlots();
}
root.addEventListener('click', function(e){
var sz = e.target.closest('.icb-size');
if (sz){ if (!sz.disabled){ state.slots[Number(sz.dataset.i)].size = sz.dataset.size; renderSlots(); } return; }
var pk = e.target.closest('[data-pick]');
if (pk){ openSheet(Number(pk.dataset.pick)); return; }
var nd = e.target.closest('[data-nudge]');
if (nd){ setTier(Number(nd.dataset.nudge)); return; }
if (e.target.closest('.icb-tier-body')) return;
var t = e.target.closest('.icb-tier');
if (t && !t.classList.contains('is-on')) setTier(Number(t.dataset.tier));
});
root.addEventListener('keydown', function(e){
if (e.key !== 'Enter' && e.key !== ' ') return;
var t = e.target.closest && e.target.closest('.icb-tier');
if (t && e.target === t){ e.preventDefault(); setTier(Number(t.dataset.tier)); }
});
var sheet = document.getElementById('icb-sheet'), grid = document.getElementById('icb-sheet-grid'), tabs = document.getElementById('icb-sheet-tabs'), pickFor = 0;
var kinds = data.kinds || [], activeKind = data.currentKind || 'boxing';
function renderTabs(){
var html = '';
kinds.forEach(function(k){
var n = data.products.filter(function(pr){ return pr.kind === k.handle; }).length;
if (!n) return;
html += '<button type="button" role="tab" class="icb-tab'+(k.handle===activeKind?' is-on':'')+'" data-kind="'+esc(k.handle)+'" aria-selected="'+(k.handle===activeKind)+'">'+esc(k.label)+'</button>';
});
tabs.innerHTML = html;
}
function renderGrid(){
var html = '';
data.products.forEach(function(pr){
if (pr.kind !== activeKind) return;
html += '<button type="button" class="icb-sheet-item'+(state.slots[pickFor].handle===pr.handle?' is-on':'')+'" data-h="'+esc(pr.handle)+'">' +
'<img src="'+esc(pr.img)+'" alt="" loading="eager"><span>'+esc(shortTitle(pr.title))+'</span></button>';
});
grid.innerHTML = html; grid.scrollTop = 0;
}
function openSheet(i){
pickFor = i;
var chosen = state.slots[i].handle ? byHandle[state.slots[i].handle] : null;
activeKind = (chosen && chosen.kind) || activeKind;
renderTabs(); renderGrid();
sheet.hidden = false; document.body.style.overflow = 'hidden';
}
function closeSheet(){ sheet.hidden = true; document.body.style.overflow = ''; }
sheet.addEventListener('click', function(e){
if (e.target.closest('[data-close]')){ closeSheet(); return; }
var tb = e.target.closest('.icb-tab');
if (tb){ activeKind = tb.dataset.kind; renderTabs(); renderGrid(); return; }
var it = e.target.closest('.icb-sheet-item');
if (it){
var s = state.slots[pickFor]; s.handle = it.dataset.h;
var pr = byHandle[s.handle];
if (single(pr)) s.size = pr.variants[0].t;
else {
var has = function(size){ return pr.variants.some(function(v){ return v.t === size && v.a; }); };
if (s.size && !has(s.size)) s.size = null;
var first = state.slots[0];
if (!s.size && pickFor > 0 && first.size && has(first.size)) s.size = first.size;   // same size as pair 1 when it exists
}
closeSheet(); renderSlots();
var el = root.querySelector('.icb-slot[data-i="'+pickFor+'"]');
if (el && !s.size) el.scrollIntoView({behavior:'smooth', block:'center'});
}
});
document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
function variantFor(s){
if (!s.handle || !s.size) return null;
var pr = byHandle[s.handle];
for (var k = 0; k < pr.variants.length; k++) if (pr.variants[k].t === s.size && pr.variants[k].a) return pr.variants[k].id;
return null;
}
function firstMissing(){
for (var i = 0; i < state.qty; i++) if (!variantFor(state.slots[i])) return i;
return -1;
}
function eventsReady(){
if (window.YBEvents) return Promise.resolve(window.YBEvents);
return new Promise(function(res){
var t = setTimeout(function(){ res(null); }, 2500);
document.addEventListener('yb:events-ready', function(){ clearTimeout(t); res(window.YBEvents); }, { once: true });
});
}
function addAll(){
var missing = firstMissing();
if (missing >= 0){
root.querySelectorAll('.icb-slot').forEach(function(x){ x.classList.remove('is-missing'); });
var el = root.querySelector('.icb-slot[data-i="'+missing+'"]');
if (el){ el.classList.add('is-missing'); el.scrollIntoView({behavior:'smooth', block:'center'}); }
return;
}
var map = {}, order = [];
for (var i = 0; i < state.qty; i++){
var vid = variantFor(state.slots[i]);
if (!map[vid]){
map[vid] = { id: Number(vid), quantity: 0 };
if (isPO(state.slots[i].handle)) map[vid].properties = { 'Pre-order': 'Ships ' + SHIP };
order.push(vid);
}
map[vid].quantity++;
}
var payload = order.map(function(v){ return map[v]; }), count = state.qty;
var ids = []; document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(c){ if (ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId); });
note.style.color = '';
atc.disabled = true; var old = atcLabel.textContent; atcLabel.textContent = 'Adding…';
var body = { items: payload }; if (ids.length) body.sections = ids.join(',');
fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) })
.then(function(r){ return r.json(); })
.then(function(res){
if (res.status) throw new Error(res.description || res.message);
return eventsReady().then(function(ev){
var E = ev && ev.CartAddEvent;
if (!E){ window.location.href = '/cart'; return; }
return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
root.dispatchEvent(new E(cart, 'yb-buybox', { source: 'product-form-component', itemCount: count, productId: String(cur.pid), sections: res.sections }));
var drawer = document.querySelector('cart-drawer-component');
if (drawer){ try { if (typeof drawer.open === 'function') drawer.open(); else if (typeof drawer.showDialog === 'function') drawer.showDialog(); } catch (e) {} }
});
});
})
.catch(function(err){
note.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
note.style.color = '#e0362a';
})
.then(function(){ atc.disabled = false; atcLabel.textContent = old; updateCta(); });
}
atc.addEventListener('click', addAll);
stickyBtn.addEventListener('click', function(){
var r = atc.getBoundingClientRect(), visible = r.top < window.innerHeight && r.bottom > 0;
var tier = root.querySelector('.icb-tier.is-on');
if (firstMissing() >= 0 && !visible && tier) tier.scrollIntoView({behavior:'smooth', block:'center'});
addAll();
});
if ('IntersectionObserver' in window){
var io = new IntersectionObserver(function(en){
var past = en[0].boundingClientRect.top < 0 && !en[0].isIntersecting;
sticky.classList.toggle('is-show', past);
sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
}, { threshold: 0 });
io.observe(atc);
}
renderSlots();
})();